/**
 * TTJ floating actions: scroll-to-top behaviour.
 *
 * The WhatsApp button is a plain link and needs no script. This file only
 * handles the scroll-to-top button rendered by snippets/ttj-floating-actions.liquid:
 *   - hidden while the page is near the top; shown once the visitor has
 *     scrolled past the threshold (data-threshold, from the theme setting)
 *   - click / Enter / Space scrolls smoothly to the top
 *   - smooth scrolling is skipped when the visitor prefers reduced motion
 * No external libraries.
 */
(function () {
  'use strict';

  function init() {
    var button = document.querySelector('[data-ttj-scroll-top]');
    if (!button || button.dataset.ttjBound === 'true') return;
    button.dataset.ttjBound = 'true';

    var threshold = parseInt(button.getAttribute('data-threshold'), 10);
    if (!isFinite(threshold) || threshold < 0) threshold = 300;

    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    var ticking = false;

    function getScrollTop() {
      return window.pageYOffset || document.documentElement.scrollTop || 0;
    }

    function update() {
      ticking = false;
      button.classList.toggle('is-visible', getScrollTop() > threshold);
    }

    function onScroll() {
      // Batch work into one update per animation frame.
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    }

    // Keyboard users: once the page jumps to the top the button hides, so hand
    // focus back to the top of the document instead of losing it.
    function resetFocusToTop() {
      var body = document.body;
      var hadTabindex = body.hasAttribute('tabindex');
      if (!hadTabindex) body.setAttribute('tabindex', '-1');
      body.style.outline = 'none';
      body.focus({ preventScroll: true });
      body.addEventListener(
        'blur',
        function () {
          body.style.outline = '';
          if (!hadTabindex) body.removeAttribute('tabindex');
        },
        { once: true }
      );
    }

    button.addEventListener('click', function (event) {
      var fromKeyboard = event.detail === 0;

      window.scrollTo({
        top: 0,
        left: 0,
        behavior: reducedMotion.matches ? 'auto' : 'smooth',
      });

      if (fromKeyboard) resetFocusToTop();
    });

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    // Set the right state immediately (e.g. page restored part-way down).
    update();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
